"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initiZiPreResult = exports.CallingProperty = exports.SwapDirection = void 0;
var SwapDirection;
(function (SwapDirection) {
    SwapDirection["ExactIn"] = "ExactIn";
    SwapDirection["ExactOut"] = "ExactOut";
})(SwapDirection = exports.SwapDirection || (exports.SwapDirection = {}));
var CallingProperty;
(function (CallingProperty) {
    CallingProperty["Long"] = "long";
    CallingProperty["Short"] = "short";
})(CallingProperty = exports.CallingProperty || (exports.CallingProperty = {}));
const initiZiPreResult = (chainId) => {
    return {
        lastChainId: chainId,
        pathWithFee100: [],
        pathWithOutFee100: [],
        pool: new Map(),
        poolPoint: new Map()
    };
};
exports.initiZiPreResult = initiZiPreResult;
